export default function Section7() {
  return (
    <div className="Section2">
      {/* H1 above hero section */}
      <div className="text-center mb-8 py-10">
        <h1 className="text-[28px] md:text-[36px] font-bold text-black">
          Email Marketing Services
        </h1>
      </div>

      <div className="section2-container my-[7%] md:my-0 md:justify-evenly md:items-center md:flex px-[20px] md:p-[50px_30px_0px_30px]">
        <div className="md:w-[36%]">
          <h2 className="text-[24px] md:text-[34px] pb-[2%] leading-[32px] md:leading-[41px] font-bold text-[#DA2128] my-[0.67em]">
            Email Marketing Services That Drive Revenue & Results
          </h2>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            Maximize engagement, boost conversions, and grow revenue with data-driven
            email marketing campaigns tailored to your audience.
          </p>

          <div className="flex gap-4 mt-4">
            <a
              href="https://mean3.com/contact-mean3/"
              className="bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
            >
              Get a Converting Funnel
            </a>
            <a
              href="https://mean3.com/contact-mean3/"
              className="border border-[#DA2128] text-[#DA2128] py-2 px-6 rounded-md font-semibold hover:bg-[#DA2128] hover:text-white transition"
            >
              Schedule a Demo
            </a>
          </div>
        </div>

        <div className="w-full img-cont md:w-auto">
          <img
            className="w-full md:w-auto"
            src="../../../../assets/computer-email-marketing.png"
            alt="Email Marketing Illustration"
          />
        </div>
      </div>

      <div className="line mx-auto my-[55px] md:my-[4%] w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
